import React, { useEffect, useState } from "react";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";

import Loader from "../../Component/Loader";
import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";
import SubmitButton from "../../Component/SubmitButton";
import CommonPopup from "../../Component/CommonPopup";

const WinnerAgency = () => {

  const { kv, set } = useStoreKv();
  const gameObj = kv.game_obj || [];

  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(null);
  const [loading2, setLoading2] = useState(null);
  const [gameData, setGameData] = useState(gameObj);
  const [popup, setPopup] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);
  const [pendingUpdate, setPendingUpdate] = useState(null);

  const buildUpdates = (combinations = []) => {
    const updates = [];
    for (const c of combinations) {
      const raw = String(c?.price ?? "").trim();
      if (raw === "") {
        throw new Error(`Price is required for ${c?.name || c?.column || "entry"}`);
      }
      const price = Number(raw);
      if (!Number.isFinite(price)) {
        throw new Error(`Invalid price for ${c?.name || c?.column || "entry"}`);
      }
      updates.push({ column: c.column, price });
    }
    return updates;
  };

  const getList = async () => {
    try {
      // setLoading(true);
      const res = await get(`${URLS.PRICELIST}`);
      console.log("Fetched data:", res);

      if (res?.status === "success" && Array.isArray(res?.data)) {
        setGameData(res?.data);
        set("game_obj", res?.data);
      } else {
        setGameData([]);
        set("game_obj", []);
      }
    } catch (err) {
      Toast("Failed to load data");
      console.error(err);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);


  // const handleChange = (fee_price_id, column, value) => {
  //   setGameData((prev) =>
  //     prev.map((ticket) =>
  //       ticket.variations?.some(v => v.fee_price_id === fee_price_id)
  //         ? {
  //           ...ticket,
  //           variations: ticket.variations.map((v) =>
  //             v.fee_price_id === fee_price_id
  //               ? {
  //                 ...v,
  //                 combinations: v.combinations.map((c) =>
  //                   c.column === column ? { ...c, price: value } : c
  //                 ),
  //               }
  //               : v
  //           ),
  //         }
  //         : ticket
  //     )
  //   );
  // };


  const handleUpdateSingle = async (variation) => {

    try {
      if (!variation?.fee_price_id) {
        Toast("Missing price row to update");
        return;
      }
      setLoading1(variation?.type);

      const updates = buildUpdates(variation?.combinations);

      const payload = {
        fee_price_id: variation.fee_price_id,
        type: variation.type,
        updates,
      };

      console.log("Update Payload:", payload);

      const res = await post(`${URLS.PRICEUPADTE}`, payload);

      if (res?.status === "success") {
        Toast("Updated successfully");
        getList(); // refresh data
      } else {
        Toast(res?.message || "Failed to update");
      }
    } catch (err) {
      Toast(err?.message || "Failed to update");
      console.error(err);
    } finally {
      setLoading1(null);
      setPopup(false);
      setPopupLoading(false);
      setPendingUpdate(null);
    }
  };

  const confirmUpdate = (updateFunction, ...args) => {
    setPendingUpdate({ func: updateFunction, args });
    setPopup(true);
  };

  const executePendingUpdate = async () => {
    if (pendingUpdate) {
      setPopupLoading(true);
      await pendingUpdate.func(...pendingUpdate.args);
    }
  };


  const handleChange = (fee_price_id, column, value) => {
    setGameData((prev) =>
      prev.map((game) =>
        game.variations?.some((v) => v.fee_price_id === fee_price_id)
          ? {
            ...game,
            variations: game.variations.map((v) =>
              v.fee_price_id === fee_price_id
                ? {
                  ...v,
                  combinations: v.combinations.map((c) =>
                    c.column === column ? { ...c, price: value } : c
                  ),
                }
                : v
            ),
          }
          : game
      )
    );
  };


  const handleUpdate = async ({ gameIndex, excludeVariationIndexes = [] }) => {
    try {
      if (gameIndex === undefined || gameIndex === null) {
        Toast("Missing game selection");
        return;
      }
      setLoading2(gameIndex);

      const game = gameData?.[gameIndex];
      const variations = Array.isArray(game?.variations) ? game.variations : [];
      if (!variations.length) {
        Toast("No rows found to update");
        return;
      }

      const updatesPayload = variations
        .filter((_, idx) => !excludeVariationIndexes.includes(idx))
        .map((variation) => ({
          fee_price_id: variation.fee_price_id,
          type: variation.type,
          updates: buildUpdates(variation?.combinations),
        }));

      for (const payload of updatesPayload) {
        const res = await post(`${URLS.PRICEUPADTE}`, payload);
        if (res?.status !== "success") {
          Toast(res?.message || "Failed to update some entries");
          return;
        }
      }

      Toast("Updated successfully");
      await getList(); // Refresh data
    } catch (err) {
      Toast(err?.message || "Failed to update tables");
      console.error(err);
    } finally {
      setLoading2(null);
      setPopup(false);
      setPopupLoading(false);
      setPendingUpdate(null);
    }
  };

  const threegame = gameData[2];
  const fourgame = gameData[3];

  return (
    <div className="dashRightView d-flex ac-jb flex-column">
      <CustomScroll >
        <div style={{ paddingBottom: 80, paddingTop: 0, paddingRight: 20 }} className="container_overalls">
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-3">
            This 4 & 3 digit game is based on the daily result of Kerala & Dear
            lottery first prize reults with the last 4 & 3 digits based.
          </p>
          <label style={{ marginTop: 25 }} className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary1">
            Kerala [Upto 4 digits game]
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 Blue_color">
            3:00 PM
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 ">
            An example of a first price ticket is 5635
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 ">
            X=5, A=6, B=3, C=5, AB=63, BC=35, AC=65,
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 ">
            ABC = 635, XABC = 5635
          </p>

          <label style={{ marginTop: 25 }} className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary1">
            Dear [Upto 3 digits game]:
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 Blue_color">
            01:00 PM, 06:00 PM & 08:00 PM
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 ">
            An example of a first price ticket is 062
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 ">
            A=0, B=6, C=2, AB=06, BC=62, AC=02,
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 ">
            ABC = 062
          </p>
        {/* --------------------------------------------------single-------------------------------------------------------------- */}
<label style={{ marginTop: 25 }} className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 primary1">
  Single Digit Game - A, B, C Board
</label>
<p className="f2 fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
  Single digit games can be played on any board between A, B and C.
</p>

<div className="row" style={{ display: 'flex', flexDirection: 'column' }}>
  {gameData[0]?.variations?.length > 0 ? (
    <>
      {gameData[0].variations.map((variation, index) => (
        <div key={variation.fee_price_id || index} className="col-md-5">
          <div className="my-2 sale_value">
            <div className="w-100 d-flex ac-jc table_title4">
              <h4 className="f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center white">
                Ticket Price: {variation.ticket_price}
              </h4>
            </div>
            <table className="table3 text-center" style={{ tableLayout: 'fixed', width: '100%' }}>
              <tbody>
                <tr className="tr_table">
                  {variation.combinations?.map((item, i) => (
                    <td key={`name-${i}`} className="td_table">
                      <p className="form-control7 f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">
                        {item?.name}
                      </p>
                    </td>
                  ))}
                </tr>
                <tr className="tr_table">
                  {variation.combinations?.map((item, i) => (
                    <td key={`price-${i}`} className="td_table">
                      <input
                        type="text"
                        value={item?.price}
                        defaultValue="100"
                        className="form-control7 f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center placholdercolorchanges2"
                        onChange={(e) =>
                          handleChange(variation.fee_price_id, item.column, e.target.value)
                        }
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ))}

      {/* Single Update button at the bottom — same pattern as Three/Four Digit */}
      <div className="col-md-5 my-2">
        <SubmitButton
          onClick={() => confirmUpdate(handleUpdate, { gameIndex: 0 })}
          loading={loading2 === 0}
          disabled={loading2}
          title="Update"
        />
      </div>
    </>
  ) : (
    <p className="text-center mt-4">Loading Single Digit Game...</p>
  )}
</div>

{/* --------------------------------------------------Double-------------------------------------------------------------- */}
<label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mt-4 primary1">
  Double Digit Game - AB, BC, AC
</label>
<p className="f2 fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
  In a double digit game, players can pick two numbers in the last three digits
  of the result in the combination of AB, BC and AC.
</p>

<div className="row" style={{ display: 'flex', flexDirection: 'column' }}>
  {gameData[1]?.variations?.length > 0 ? (
    <>
      {gameData[1].variations.map((variation, index) => (
        <div key={variation.fee_price_id || index} className="col-md-5">
          <div className="my-2 sale_value">
            <div className="w-100 d-flex ac-jc table_title4">
              <h4 className="f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center white">
                Ticket Price: {variation.ticket_price}
              </h4>
            </div>
            <table className="table3 text-center" style={{ tableLayout: 'fixed', width: '100%' }}>
              <tbody>
                <tr className="tr_table">
                  {variation.combinations?.map((item, i) => (
                    <td key={`name-${i}`} className="td_table">
                      <p className="form-control7 f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">
                        {item?.name}
                      </p>
                    </td>
                  ))}
                </tr>
                <tr className="tr_table">
                  {variation.combinations?.map((item, i) => (
                    <td key={`price-${i}`} className="td_table">
                      <input
                        type="text"
                        value={item?.price}
                        defaultValue="100"
                        className="form-control7 placholdercolorchanges2 f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center"
                        onChange={(e) =>
                          handleChange(variation.fee_price_id, item.column, e.target.value)
                        }
                      />
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ))}

      {/* Single Update button at the bottom */}
      <div className="col-md-5 my-2">
        <SubmitButton
          onClick={() => confirmUpdate(handleUpdate, { gameIndex: 1 })}
          loading={loading2 === 1}
          disabled={loading2}
          title="Update"
        />
      </div>
    </>
  ) : (
    <p className="text-center mt-4">Loading Double Digit Game...</p>
  )}
</div>
          {/* --------------------------------------------------triple-------------------------------------------------------------- */}

          <label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mt-4 primary1">
            Three Digit Game - ABC
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 ">
            If a player places a bet on an ABC 3 digit game in a particular
            lottery there is a three chance of winning.
          </p>


          <div className="row" style={{ display: 'flex', flexDirection: 'column' }}>
            {threegame ? (
              <>
                {threegame.variations?.filter((ticket) => ticket.fee_price_id !== 4).map((ticket, index) =>
               
                    <div key={ticket.fee_price_id || index} className="col-md-5">
                      <div className="my-2 sale_value">
                        {/* Title */}
                        <div className="w-100 d-flex ac-jc table_title4">
                          <h4 className="f3 text-center white f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                            Ticket Price: {ticket.ticket_price}
                          </h4>
                        </div>

                        {/* Combinations Table */}
                        <table className="table3 text-center" style={{ tableLayout: 'fixed', width: '100%' }}>
                          <tbody>
                            <tr className="tr_table">
                              {ticket.combinations.map((header, i) => (
                                <td key={i} className="td_table">
                                  <p className="form-control7 f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">
                                    {header.name}
                                  </p>
                                </td>
                              ))}
                            </tr>
                            <tr className="tr_table">
                              {ticket.combinations.map((val, i) => (
                                <td key={i} className="td_table">
                                  <input
                                    type="number"
                                    value={val.price}
                                    onChange={(e) =>
                                      handleChange(
                                        ticket.fee_price_id,
                                        val.column,
                                        e.target.value
                                      )
                                    }
                                    className="placholdercolorchanges2 form-control7 f3 text-center fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 placholdercolorchanges2"
                                  />
                                </td>
                              ))}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  
                )}

                {/* Single Update Button */}
                <div className="col-md-5 my-2">
                  {/* <button
                    onClick={() => confirmUpdate(handleUpdate, { gameIndex: 2, excludeVariationIndexes: [1] })}
                    disabled={loading2}
                    className="add-button f3 fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 white"
                  >
                    {loading2 === 2 ? <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white" }}
                      ></span>
                    </> : "Update"}
                  </button> */}
                  <SubmitButton
                    onClick={() => confirmUpdate(handleUpdate, { gameIndex: 2, excludeVariationIndexes: [1] })}
                    disabled={loading2}
                    loading={loading2 === 2}
                    title="Update"
                  />
                </div>
              </>
            ) : (
              <p className="text-center mt-4">Loading Three Digit Game...</p>
            )}
          </div>

          {/* --------------------------------------------------triple ABC-------------------------------------------------------------- */}

          <label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mt-4 primary1">
            Three Digit Game - ABC
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
            If a player places a bet on an ABC 3 digit game in a particular lottery there is a two chance of winning.
          </p>

          {gameData[2]?.variations?.filter((ticket) => ticket.fee_price_id === 4).map((ticket, index) =>
            
              <div key={ticket.fee_price_id || index} className="col-md-5">
                <div className="my-2 sale_value">
                  {/* Ticket Title */}
                  <div className="w-100 d-flex ac-jc table_title4">
                    <h4 className="f3 text-center white f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                      Ticket Price: {ticket.ticket_price}
                    </h4>
                  </div>

                  {/* Combinations Table */}
                  <table className="table3 text-center" style={{ tableLayout: 'fixed', width: '100%' }}>
                    <tbody>
                      {/* Header Row */}
                      <tr className="tr_table">
                        {ticket.combinations.map((header, i) => (
                          <td key={i} className="td_table">
                            <p className="form-control7 f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">{header.name}</p>
                          </td>
                        ))}
                      </tr>

                      {/* Input Row */}
                      <tr className="tr_table">
                        {ticket.combinations.map((val, i) => (
                          <td key={i} className="td_table">
                            <input
                              type="number"
                              value={val.price}
                              onChange={(e) =>
                                handleChange(ticket.fee_price_id, val.column, e.target.value)
                              }
                              className="placholdercolorchanges2 form-control7 f3 text-center fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                            />
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
          
          )}

          <div className="col-md-5 my-2 mt-3">
            {/* <button
              onClick={() => confirmUpdate(handleUpdateSingle, gameData[2]?.variations?.[1])}
              className="add-button f3 fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 white"
            >
              {loading1 === gameData[2]?.variations?.[1]?.type ? <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white" }}
                ></span>
              </> : "Update"}
            </button> */}
            <SubmitButton
              onClick={() => confirmUpdate(handleUpdateSingle, gameData[2]?.variations?.[1])}
              loading={loading1 === gameData[2]?.variations?.[1]?.type}
              title="Update"
            />
          </div>


          {/* --------------------------------------------------Four ABC-------------------------------------------------------------- */}
          <label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mt-4 primary1">
            Four Digit Game - XABC
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 black">
            This one available only in Kerala Lottery.
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1">
            If a player places a bet on an XABC 4 digit game in a particular
            lottery there is a 4 chance of winning.
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1">
            (XABC Matching or ABC Matching or BC Matching or C Matching)
          </p>

          <div className="row" style={{ display: 'flex', flexDirection: 'column' }}>
            {fourgame ? (
              <>
                {/* <label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mt-4 primary">
                {fourgame.game_type}
              </label>
              <p className="f2 fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1">
                {fourgame.description}
              </p> */}

                {fourgame.variations?.map((ticket, index) =>
                  index !== 0 ? (
                    <div key={ticket.fee_price_id || index} className="col-md-5">
                      <div className="my-2 sale_value ">
                        {/* Title */}
                        <div className="w-100 d-flex ac-jc table_title4">
                          <h4 className="f3 text-center white f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                            Ticket Price: {ticket.ticket_price}
                          </h4>
                        </div>

                        {/* Combinations Table */}
                        <table className="table3 text-center" style={{ tableLayout: 'fixed', width: '100%' }}>
                          <tbody>
                            <tr className="tr_table">
                              {ticket.combinations.map((header, i) => (
                                <td key={i} className="td_table">
                                  <p className="form-control7 f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">
                                    {header.name}
                                  </p>
                                </td>
                              ))}
                            </tr>
                            <tr className="tr_table">
                              {ticket.combinations.map((val, i) => (
                                <td key={i} className="td_table">
                                  <input
                                    type="number"
                                    value={val.price}
                                    onChange={(e) =>
                                      handleChange(
                                        ticket.fee_price_id,
                                        val.column,
                                        e.target.value
                                      )
                                    }
                                    className="placholdercolorchanges2 form-control7 f3 text-center fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                                  />
                                </td>
                              ))}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : null
                )}

                {/* Single Update Button */}
                <div className="col-md-5 my-2">
                  {/* <button
                    onClick={() => confirmUpdate(handleUpdate, { gameIndex: 3, excludeVariationIndexes: [0] })}
                    disabled={loading2}
                    className="add-button f3 fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 black"
                  >
                    {loading2 === 3 ? <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "black" }}
                      ></span>
                    </> : "Update"}
                  </button> */}
                  <SubmitButton
                    onClick={() => confirmUpdate(handleUpdate, { gameIndex: 3, excludeVariationIndexes: [0] })}
                    disabled={loading2}
                    loading={loading2 === 3}
                    title="Update"
                  />
                </div>
              </>
            ) : (
              <p className="text-center mt-4">Loading Three Digit Game...</p>
            )}
          </div>

          {/* --------------------------------------------------fourXABC-------------------------------------------------------------- */}
          <label className="f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 mt-4 primary1">
            Four Digit Game - XABC
          </label>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 my-1 black">
            This is available in Dear and Kerala Lottery.
          </p>
          <p className=" f2  fs-xs-14 fs-sm-13 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 .my-1">
            If a player places a bet on an XABC 4 digit game in a particular
            lottery there is a one chance of winning only in four digit winning
          </p>

          {gameData[3]?.variations?.map((ticket, index) =>
            index === 0 ? (
              <div key={ticket.fee_price_id || index} className="col-md-5">
                <div className="my-2 sale_value">
                  {/* Ticket Title */}
                  <div className="w-100 d-flex ac-jc table_title4">
                    <h4 className="f3 text-center white f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                      Ticket Price: {ticket.ticket_price}
                    </h4>
                  </div>

                  {/* Combinations Table */}
                  <table className="table3 text-center" style={{ tableLayout: 'fixed', width: '100%' }}>
                    <tbody>
                      {/* Header Row */}
                      <tr className="tr_table">
                        {ticket.combinations.map((header, i) => (
                          <td key={i} className="td_table">
                            <p className="form-control7 f3 fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 text-center">{header.name}</p>
                          </td>
                        ))}
                      </tr>

                      {/* Input Row */}
                      <tr className="tr_table">
                        {ticket.combinations.map((val, i) => (
                          <td key={i} className="td_table">
                            <input
                              type="number"
                              value={val.price}
                              onChange={(e) =>
                                handleChange(ticket.fee_price_id, val.column, e.target.value)
                              }
                              className="placholdercolorchanges2 form-control7 f3 text-center fs-xs-17 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                            />
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null
          )}

          <div className="col-md-5 my-2 mt-3">
            {/* <button
              onClick={() => confirmUpdate(handleUpdateSingle, gameData[3]?.variations?.[0])}
              className="add-button f3 fs-xs-15 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 white"
            >
              {loading1 === gameData[3]?.variations?.[0]?.type ? <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white" }}
                ></span>
              </> : "Update"}
            </button> */}
            <SubmitButton
              onClick={() => confirmUpdate(handleUpdateSingle, gameData[3]?.variations?.[0])}
              loading={loading1 === gameData[3]?.variations?.[0]?.type}
              title="Update"
            />
          </div>

          {loading && <Loader />}
          {/* {popup && (
            <div className="img-popup-design">
              <div className="img-popup">
                <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
                  Are you sure you want to Update?
                </p>
                <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2  f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
                  <button onClick={() => setPopup(false)} className="no-btn w-40">
                    No
                  </button>
                  <button
                    onClick={executePendingUpdate}
                    className="yes-btn f2 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
                  >
                    {popupLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                          style={{ color: "white", padding: 8 }}
                        ></span>
                      </>
                    ) : (
                      <span style={{ top: -1.5, position: 'relative' }}>Yes</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )} */}

          <CommonPopup
            isOpen={popup}
            message={"Are you sure you want to Update?"}
            onClose={() => setPopup(false)}
            onConfirm={executePendingUpdate}
            loading={popupLoading}
            confirmText="Yes"
          />
        </div>
      </CustomScroll>
    </div >
  );
};

export default WinnerAgency;
